import { DomSanitizer } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'tiSafeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html: string) {
    // because we use this pipe for innerHtml and it will show undefined string on the view
    return html == null ? '' : this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
